/**
* @author ayou[beica1@outook.com]
* @date 2022/3/9 16:23
* @description
*   Account.vue of WeTrade
*/
<template>
<div class="p-20">
  <div class="df-middle">
    <button :class="['switch', !isDemoAccount && 'active']" @click="useDemo(false)">
      Live account
    </button>
    <button :class="['switch', isDemoAccount && 'active']" @click="useDemo(true)">
      Demo account
    </button>
    <AccountRelated use-in-real>
      <TheFirstDepositCard />
    </AccountRelated>
  </div>
  <div class="d-f box">
    <div class="user__asset p-20">
      <TheAsset>
        <AccountRelated use-in-real>
          <div class="mt-20 d-f">
            <OnlyApp tag="button" class="flex-3 btn line sm out br-sm">
              <t path="trade_11" #="{td}" custom>{{td || 'Withdrawal'}}</t>
            </OnlyApp>
            <router-link #="{navigate}" custom to="/in">
              <button class="flex-5 btn success sm ml-10 br-sm" @click="navigate">
                <t path="trade_12" #="{td}" custom>{{td || 'Deposit'}}</t>
              </button>
            </router-link>
          </div>
        </AccountRelated>
      </TheAsset>
    </div>
    <div class="flex-1 scroll-y list" style="height: 240px">
      <div class="df-middle m-16">
        <div class="change-item toggle__line-btn anchor" :class="{'active': active === OrderType.position}"
          @click="changeClick">
          <PositionBarWithBadge />
        </div>
        <div class="change-item toggle__line-btn anchor" :class="{'active': active === OrderType.commissions}"
          @click="changeClick">
          <CommissionBarWithBadge />
        </div>
      </div>
      <Positions v-if="active === OrderType.position" />
      <TheCommissions v-if="active === OrderType.commissions" />
    </div>
  </div>
</div>
</template>

<script lang="ts">
import Positions from '@/modules/trade/components/ThePositions.vue'
import TheCommissions from '@/modules/trade/components/TheCommissions.vue'
import OnlyApp from '@/provider/OnlyApp.vue'
import CommissionBarWithBadge from '@/views/CommissionBarWithBadge.vue'
import PositionBarWithBadge from '@/views/PositionBarWithBadge.vue'
import TheAsset from '@/modules/trade/components/TheAsset.vue'
import AccountRelated from '@/provider/AccountRelated.vue'
import TheFirstDepositCard from '@/modules/trade/components/TheFirstDepositCard.vue'
import { AccountType } from '@/state'
import { changeAccountType, isDemoAccount } from '@/state/accountType'
import { defineComponent, shallowRef } from 'vue'

enum OrderType {
  position,
  commissions,
}

export default defineComponent({
  name: 'Account',
  components: {
    OnlyApp,
    Positions,
    AccountRelated,
    TheAsset,
    TheCommissions,
    CommissionBarWithBadge,
    PositionBarWithBadge,
    TheFirstDepositCard,
  },
  setup () {
    const useDemo = (demo = false) => {
      changeAccountType(demo ? AccountType.DEMO : AccountType.REAL)
    }

    const active = shallowRef(OrderType.position)

    const changeClick = () => {
      active.value = active.value === OrderType.position ? OrderType.commissions
        : OrderType.position
    }

    return {
      useDemo,
      isDemoAccount,
      active,
      OrderType,
      changeClick,
    }
  },
})
</script>

<style scoped lang="scss">
button{
  cursor: pointer;
}
.box {
  border-top-left-radius: 0;
}

.user__asset {
  min-width: 350px;
  max-width: 350px;
}

.list {
  border-left: 1px solid var(--color-border);
}

.switch {
  width: 120px;
  height: 40px;
  margin-right: 5px;
  background: var(--color-hover);
  border: 1px solid var(--color-border);
  border-radius: 6px 6px 0 0;
  border-bottom: none;
  font-size: 14px;
  font-weight: bold;
  color: var(--color-title);

  &.active {
    position: relative;
    color: var(--color-text);
    background: var(--color-white);

    &::after {
      position: absolute;
      left: 0;
      right: 0;
      bottom: -1px;
      border-bottom: 1px solid var(--color-white);
      content: '';
    }
  }
}

.change-item {
  height: 26px;
  line-height: 26px;
  margin-right: 6px;
  padding: 0 8px;
}

</style>
